import { httpBatchLink, createTRPCProxyClient } from "@trpc/client";
import superjson from "superjson";
import type { AppRouter } from "../../../server/routers";

export const apiClient = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: "/api/trpc",
      transformer: superjson,
      fetch(input, init) {
        return globalThis.fetch(input, {
          ...(init ?? {}),
          credentials: "include",
          cache: "no-store",
        });
      },
    }),
  ],
});
